import React from "react";
import { connect } from "react-redux";
import LoadingComponent from "../LoadingComponent/LoadingComponent";

const PermissionComponentCheck = (props) => {
  const { requiredPermission } = props;

  if (!props.role || !props.activePermissions) {
    return <LoadingComponent />;
  } else {
    // Get the array of permissions that are enabled for the current user
    let rolePermissions = props.activePermissions.filter(
      (x) => x.role.code === props.role
    )[0];
    if(!props.requiredPermission){
      // If not permission is provided, default to allowed
      return <>{props.children}</>;
    } else if(
      rolePermissions?.permissions?.filter((x) => x.code === requiredPermission).length > 0
    ) {
      return <>{props.children}</>;
    } else if(props.denyAction === "showAlternative"){
      return <>{props.alternativeComponent}</>;
    }else {
      return null;
    }
  }
};

PermissionComponentCheck.defaultProps = {
  requiredPermission: "",
  denyAction: "hide",
  children: null,
  alternativeComponent: null
};

const mapStateToProps = (state) => {
  return { 
    activePermissions: state.permissionStore.activePermissions,
    role: state.auth.role
  };
};
export default connect(mapStateToProps, {})(PermissionComponentCheck);
